import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import classes from './styles.module.scss'

interface CircularStaticProps {
  progress: number
}

const CircularStatic = (props: CircularStaticProps) => {
  // const { progress } = props
  const { progress } = props

  return (
    <Box className={classes.circleProgress}>
      {progress === 0 ? (
        <CircularProgress size="64px" />
      ) : (
        <CircularProgress
          variant="determinate"
          {...props}
          size="64px"
          value={progress}
        />
      )}

      <Box
        className={classes.text}
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
        >{`${progress}%`}</Typography>
      </Box>
    </Box>
  )
}

export default CircularStatic
